import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { fmtRON, imgUrl } from "../components/ProductCard";
import { ShoppingCart, Trash2, Minus, Plus, ArrowRight, Zap } from "lucide-react";

export default function CartPage() {
  const { items, setQty, remove, total } = useCart();

  return (
    <div data-testid="cart-page" className="max-w-4xl mx-auto px-6 py-14">
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Cosul tau</div>
      <h1 className="font-display text-4xl uppercase">Cos de <span className="text-[#00E5FF]">cumparaturi</span></h1>

      {items.length === 0 ? (
        <div className="border border-dashed border-[#00E5FF]/20 p-20 text-center mt-10">
          <ShoppingCart className="w-12 h-12 mx-auto mb-4 text-[#00E5FF]/30" />
          <div className="text-neutral-500">Cosul tau e gol.</div>
          <Link to="/magazin" data-testid="empty-cart-shop-link" className="inline-flex items-center gap-2 text-[#00E5FF] text-sm uppercase tracking-widest mt-4 hover:text-white transition-colors">
            Mergi la magazin <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <>
          <div className="mt-10 divide-y divide-neutral-900 border border-neutral-900">
            {items.map((i) => (
              <div key={i.product_id} data-testid={`cart-item-${i.product_id}`} className="flex items-center gap-4 p-4">
                <div className="w-20 h-20 bg-[#0B0B0B] border border-neutral-900 flex-shrink-0 overflow-hidden">
                  {i.image ? <img src={imgUrl(i.image)} alt="" className="w-full h-full object-cover" />
                    : <div className="w-full h-full flex items-center justify-center text-[#00E5FF]/20"><Zap className="w-8 h-8" /></div>}
                </div>
                <div className="flex-1 min-w-0">
                  <Link to={`/produs/${i.product_id}`} className="font-semibold text-sm hover:text-[#00E5FF] transition-colors">{i.name}</Link>
                  <div className="text-[#00E5FF] font-bold mt-1">{fmtRON(i.price)}</div>
                </div>
                <div className="flex items-center border border-neutral-800">
                  <button data-testid={`cart-minus-${i.product_id}`} onClick={() => setQty(i.product_id, i.qty - 1)} className="p-2 hover:text-[#00E5FF]"><Minus className="w-3.5 h-3.5" /></button>
                  <div className="w-8 text-center text-sm font-bold">{i.qty}</div>
                  <button data-testid={`cart-plus-${i.product_id}`} onClick={() => setQty(i.product_id, i.qty + 1)} className="p-2 hover:text-[#00E5FF]"><Plus className="w-3.5 h-3.5" /></button>
                </div>
                <div className="w-24 text-right font-bold text-sm hidden sm:block">{fmtRON(i.price * i.qty)}</div>
                <button data-testid={`cart-remove-${i.product_id}`} onClick={() => remove(i.product_id)} className="p-2 text-neutral-500 hover:text-red-400 transition-colors">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-end sm:items-center justify-between gap-6 mt-8">
            <div>
              <div className="text-[10px] uppercase tracking-widest text-neutral-500">Total</div>
              <div data-testid="cart-total" className="text-[#00E5FF] font-bold text-3xl">{fmtRON(total)}</div>
              <div className="text-xs text-neutral-600 mt-1">Livrare <span className="text-green-400 font-bold">GRATUITĂ</span> în toată țara</div>
            </div>
            <Link to="/checkout" data-testid="go-to-checkout-btn"
              className="inline-flex items-center gap-3 bg-[#00E5FF] hover:bg-[#5CEEFF] text-black font-bold px-8 py-4 uppercase tracking-wider text-sm transition-colors tx-cyan-glow">
              Finalizeaza comanda <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
